import React, { useState } from "react";
import { Alert, Button, Form, FormGroup, Input, Label, Spinner } from "reactstrap";

import { Actions, State } from "../../../types";

type Props = Readonly<{
  actions: Actions;
  auth: State["auth"];
}>;
type LoginFormState = Readonly<{
  errorMessage?: string;
  fields: {
    email: {
      error?: string;
      value: string;
    };
    password: {
      error?: string;
      value: string;
    };
  };
  loggingIn: boolean;
}>;

const DEFAULT_STATE: LoginFormState = {
  fields: {
    email: {
      value: "",
    },
    password: {
      value: "",
    },
  },
  loggingIn: false,
};

export const Login = ({ actions }: Props) => {
  const [formState, setFormState] = useState(DEFAULT_STATE);
  return (
    <Form
      onSubmit={e => {
        e.preventDefault();
        setFormState({
          errorMessage: undefined,
          fields: {
            email: {
              value: formState.fields.email.value,
            },
            password: {
              value: formState.fields.password.value,
            },
          },
          loggingIn: true,
        });
        // simulate a delay because users expect it to be more secure
        setTimeout(() => {
          actions
            .loginByForm(formState.fields.email.value, formState.fields.password.value)
            .catch(err => {
              setFormState({
                errorMessage: err.message,
                fields: formState.fields,
                loggingIn: false,
              });
            });
        }, 2000);
      }}
    >
      <FormGroup>
        <Label for="email">Email address</Label>
        <Input
          autoFocus
          disabled={formState.loggingIn}
          id="email"
          name="email"
          onChange={e => {
            setFormState({
              ...formState,
              errorMessage: undefined,
              fields: {
                ...formState.fields,
                email: {
                  value: e.target.value,
                },
              },
            });
          }}
          placeholder="email address"
          type="email"
          value={formState.fields.email.value}
        />
      </FormGroup>
      <FormGroup>
        <Label for="password">Password</Label>
        <Input
          disabled={formState.loggingIn}
          id="password"
          name="password"
          onChange={e => {
            setFormState({
              ...formState,
              errorMessage: undefined,
              fields: {
                ...formState.fields,
                password: {
                  value: e.target.value,
                },
              },
            });
          }}
          placeholder="password"
          type="password"
          value={formState.fields.password.value}
        />
      </FormGroup>
      <Alert
        color="danger"
        isOpen={formState.errorMessage !== undefined}
        toggle={() => {
          setFormState({
            ...formState,
            errorMessage: undefined,
          });
        }}
      >
        {formState.errorMessage}
      </Alert>
      <FormGroup>
        <Button
          className="ml-auto"
          color="primary"
          disabled={formState.loggingIn}
          size="sm"
          type="submit"
        >
          Login{formState.loggingIn && <Spinner className="ml-2" size="sm" />}
        </Button>
      </FormGroup>
      <hr />
      <div>
        <a href="https://api.innodata.com/recover">Recover my password</a>
      </div>
      <div>
        <a href="https://datatransformation.innodata.com/">Sign up</a>
      </div>
    </Form>
  );
};
Login.displayName = "Login";
